import type { FormDataOf } from '../../../../../types/templates';
import type { DynamicOptions } from '../../../../../types/client-handler';
import { Player, Team } from '../../../../../types/sport';
import type { ItemGroup } from '../../../../../types/templates';
import { disneyEspnHero } from '..';

import { ESPN_HERO_LEAGUES } from '../data/leagues';
import { ESPN_HEROS_BASE_URL } from '../urls';

type FormData = FormDataOf<typeof disneyEspnHero>;

const getTeamsByLeague = (leagueValue: string): Team[] => {
  const league = ESPN_HERO_LEAGUES.find(l => l.value === leagueValue);
  return league?.teams || [];
};

const getPlayersByTeam = (leagueValue: string, teamValue: string): Player[] => {
  const teams = getTeamsByLeague(leagueValue);
  const team = teams.find(t => t.value === teamValue);
  return team?.players || [];
};

export const getDynamicOptions = (
  fieldKey: string,
  formData: FormData,
  baseOptions?: DynamicOptions
): DynamicOptions | undefined => {
  const { league, teams } = formData;
  const slot1 = teams?.slot1 || null;
  const slot2 = teams?.slot2 || null;

  if (fieldKey === 'teams') {
    if (!league) return baseOptions;
    return getTeamsByLeague(league).map(t => ({
      id: t.value,
      value: t.value,
      label: t.label,
      imageUrl: `${ESPN_HEROS_BASE_URL}/${league}/${t.value}/logo.png`
    }));
  }

  if (fieldKey === 'players') {
    if (!league || !slot1 || !slot2) return [];
    return [slot1, slot2].map((teamValue): ItemGroup => {
      const teamData = getTeamsByLeague(league).find(t => t.value === teamValue);

      return {
        id: teamValue,
        label: teamData?.label ?? teamValue,
        badgeUrl: `${ESPN_HEROS_BASE_URL}/${league}/${teamValue}/logo.png`,
        items: getPlayersByTeam(league, teamValue).map(p => ({
          id: p.value,
          value: p.value,
          label: p.label,
          avatarUrl: p.imageUrl || ''
        }))
      };
    });
  }

  return baseOptions;
};
